import React from "react";
import { Tabs, theme } from 'antd';
import LotSkimList from "../components/storage-skim/LotSkimList";
import StockSkimList from "../components/storage-skim/StockSkimList";
import SkimTrack from "../components/storage-skim/SkimTrack";
import PondSkimList from '../components/setting-conponents/PondTank/PondSkimList';
import ProduceLotSkimView from "../components/storage-skim/ProduceLotSkimView";

export default function StorageSkimView() {

  const {
    token: { colorPrimary },
  } = theme.useToken();

  const items = [
    {
      key: 'lotskim',
      label: 'ล็อตบ่อยางสกิม',
      children: <LotSkimList />,
    },
    {
      key: 'produce',
      label: 'คลังสินค้า',
      children: <ProduceLotSkimView />,
    },
    {
      key: 'stock',
      label: 'พาเลท',
      children: <StockSkimList />,
    },
    {
      key: 'pond',
      label: 'บ่อสกิม',
      children: <PondSkimList />,
    },
    {
      key: 'track',
      label: 'ลู่ยางสกิม',
      children: <SkimTrack/>,
    },
  ];

  return(
    <div style={{ marginTop : 20}}>
      <Tabs
        destroyInactiveTabPane
        defaultActiveKey="task" 
        items={items} 
      />
    </div>
  )
}